/* eslint-disable @typescript-eslint/no-explicit-any */
import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
declare const ga: any;

@Injectable()
export class AnalyticsService {
    private _enabled: boolean;

    constructor(private _location: Location, private _router: Router) {
        this._enabled = false;
    }

    trackPageViews() {
        if (this._enabled) {
            this._router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
                // ga('send', {hitType: 'pageview', page: this.location.path()});
            });
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    trackEvent(eventName: string) {
        if (this._enabled) {
            // ga('send', 'event', eventName);
        }
    }
}
